<template>
  <div class="component--zone_lms_profile">
    <table>
      <thead>
        <tr>
          <td>{{ $t("field.lms.zone_name") }}</td>
          <td class="align-right">{{ $t("field.lms.zone_max_available_current") }}</td>
          <td class="align-right">{{ $t("field.lms.max_charging_current") }}</td>
          <td class="align-right">{{ $t("field.lms.min_charging_current") }}</td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="p in profiles" :key="p.zone_lms_profile_id">
          <td>{{ p.zone_id.name_chi }}</td>
          <td class="align-right">
            <div class="value">
              <input v-model.number="p.zone_max_available_current" :max="p.zone_id.max_physical_current_limit" type="number"/>
            </div>
            <div class="unit">({{ $t("label.max") }}: {{ p.zone_id.max_physical_current_limit }}A)</div>
          </td>
          <td class="align-right">
            <div class="value">
              <input v-model.number="p.max_charging_current" type="number"/>
            </div>
            <div class="unit">A</div>
          </td>
          <td class="align-right">
            <div class="value">
              <input v-model.number="p.max_charging_current" type="number" v-if="p.lms_profile_id !==undefined && p.lms_profile_id.mode !==undefined && p.lms_profile_id.mode == 'QUEUEING'" :disabled="true"/>
              <input v-model.number="p.min_charging_current" type="number" v-else/>
            </div>
            <div class="unit">A</div>
          </td>
        </tr>
      </tbody>
    </table>
    <!-- <div class="profile" v-for="p in profiles" :key="p.zone_lms_profile_id">
      <div class="zone">{{ p.zone_id.name_chi }}</div>
      <div class="field">
        .
      </div>
    </div> -->
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  async beforeMount() {
     await this.$axios.get(`cp_zones`, {
      params: {
        loc_id: this.data.cp_loc
      }
    }).then(res=>{
      this.zones = res.data.response.dataset;
      zones.map(z=>{
        // this.profile_map[z.zone_id] = {
        //   zone_id: z
        // };
      });
      return true;
    }).catch(err=>{
      return false;
    });
    this.initProfile();
    await this.$axios.get(`zone_lms_profiles`, {
      params: {
        lms_profile_id: this.data.lms_profile_id
      }
    }).then(res=>{
      let profiles = res.data.response.dataset;
      let map = {};
      profiles.map(p=>{
        this.profile_map[p.zone_id.zone_id] = p;
      });
      return true;
    }).catch(err=>{
      return false;
    });

    Object.keys(this.profile_map).map(zid=>{
      this.profiles.push(this.profile_map[zid]);
    });
  },
  methods: {
    async save() {
      let success = true;
      let profiles = [];
      this.profiles.map((p,i)=>{
        if(typeof profiles[i] != "object") {
          profiles[i] = {};
          profiles[i] = {
            ...this.profiles[i]
          }
        }
        profiles[i].lms_profile_id = this.data.lms_profile_id;
        profiles[i].zone_id = p.zone_id.zone_id;
      });
      console.log("profile: ", this.profiles);
      await this.$axios.put(`zone_lms_profiles`, profiles).catch(err=>{
        success = false;
        this.$message({
          message: this.$t("error.generic"),
          type: 'error'
        });
        return false;
      });
      console.log("success: ", success);
      return success;
    },
    initProfile() {
      this.zones.map((z,i)=>{
        this.profile_map[z.zone_id] = {
          zone_id: z,
          zone_max_available_current: 0,
          max_charging_current: 0,
          min_charging_current: 0
        };
      });
    }
  },
  computed: {

  },
  data() {
    return {
      zones: [],
      profile_map: {},
      profiles: []
    }
  }
}
</script>

<style lang="scss" scoped>
.component--zone_lms_profile{
  table{
    width: 100%;
    td{
      .value,
      .unit{
        margin-right: 0px!important;
        display: inline-block;
      }
      .unit{
        font-size: x-small;
      }
      .value{
        input{
          width: 40px;
        }
      }
    }
  }
  .align-right{
    text-align: right;
  }
}
</style>